import { useQuery } from "react-query";

import { makeRequest } from "../../util";
import { ListActiveDestinationsResponse } from "../../types/global";

export default function useListActiveDestinations(
  pageSize: number,
  startAfterID: string | null = null,
  startAfterName: string | null = null
) {
  return useQuery<ListActiveDestinationsResponse>(
    ["list_active_destinations", pageSize, startAfterID, startAfterName],
    async () => {
      const res = await makeRequest<ListActiveDestinationsResponse>(
        "list_active_destinations",
        {
          page_size: pageSize,
          start_after_id: startAfterID,
          start_after_name: startAfterName,
        }
      );

      return res.data;
    }
  );
}
